import type { HelpFile } from '../../types/help'
import { FunctionGroupsTestIds } from '../../../testids/FunctionGroupsTestIds'

export const functionGroupsHelp: HelpFile = {
  docPage: '/docs/governance/function-groups',
  texts: {
    [FunctionGroupsTestIds.functionGroupsList]:
      'Alle plattformweit definierten Funktionsgruppen. Jede Gruppe bündelt Zugriffsprofile zu einer wiederverwendbaren, fachlich sinnvollen Rolle, die gemeinsam beantragt und rezertifiziert werden kann.',
    [FunctionGroupsTestIds.btnNewFunctionGroup]:
      'Neue Funktionsgruppe anlegen. Der Typ bestimmt, welche Attribute und Richtlinien gelten.',
    [FunctionGroupsTestIds.colName]: null,
    [FunctionGroupsTestIds.colOwner]: null,
    [FunctionGroupsTestIds.colType]: null,
  },
}
